import aunt from "./../sounds/aunt.ogg";
import brother from "./../sounds/brother.ogg";
import dad from "./../sounds/dad.ogg";
import grandma from "./../sounds/grandma.ogg";
import grandpa from "./../sounds/grandpa.ogg";
import mum from "./../sounds/mum.ogg";
import sister from "./../sounds/sister.ogg";
import uncle from "./../sounds/uncle.ogg";
import cat from "./../sounds/cat.ogg";
import dog from "./../sounds/dog.ogg";
import fish from "./../sounds/fish.ogg";
import hamster from "./../sounds/hamster.ogg";
import man from "./../sounds/man.ogg";
import woman from "./../sounds/woman.ogg";

export const family = [
    {
      title: "dad",
      polish: "tata",
      image:
        "https://images.unsplash.com/photo-1560266822-3336a59dc719?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDN8fHxlbnwwfHx8&auto=format&fit=crop&w=600&q=60",
        sounds: dad,
    },
    {
      title: "brother",
      polish: "brat",
      image:
        "https://images.unsplash.com/photo-1524503033411-c9566986fc8f?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTR8fGJyb3RoZXJ8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: brother,
    },
    {
      title: "aunt",
      polish: "ciocia",
      image:
        "https://thumbs.dreamstime.com/b/mother-daughter-aunt-godmother-70231253.jpg",
        sounds: aunt,
    },
    {
      title: "grandma",
      polish: "babcia",
      image:
        "https://images.unsplash.com/photo-1593100126453-19b562a800c1?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8Z3JhbmRtYXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: grandma,
    },
    {
      title: "grandpa",
      polish: "dziadek",
      image:
        "https://images.unsplash.com/photo-1586498024141-1940debde48d?ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mnx8Z3JhbmRwYXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: grandpa,
    },
    {
      title: "mum",
      polish: "mama",
      image:
        "https://images.unsplash.com/photo-1531983412531-1f49a365ffed?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjZ8fG11bXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: mum,
    },
    {
      title: "sister",
      polish: "siostra",
      image:
        "https://images.unsplash.com/photo-1606916693216-69bd7e1cf2fa?ixid=MXwxMjA3fDB8MHxzZWFyY2h8NHx8c2lzdGVyfGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: sister,
    },
    {
      title: "uncle",
      polish: "wujek",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjaDkk8P4ZX1MqzQQSUznSSbNl5ZXksi39ew&usqp=CAU",
        sounds: uncle,
    },
    {
      title: "cat",
      polish: "kot",
      image:
        "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8Y2F0fGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: cat,
    },
    {
        title: "dog",
        polish: "pies",
        image:
          "https://images.unsplash.com/photo-1554456854-55a089fd4cb2?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjV8fGRvZ3xlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
          sounds: dog,
      },
      {
        title: "fish",
        polish: "ryba",
        image:
          "https://images.unsplash.com/photo-1559717201-2879521b49f4?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MzN8fGZpc2h8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
          sounds: fish,
      },
      {
        title: "hamster",
        polish: "chomik",
        image:
          "https://images.unsplash.com/photo-1425082661705-1834bfd09dca?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8aGFtc3RlcnxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
          sounds: hamster,
      },
      {
        title: "man",
        polish: "mężczyzna",
        image:
          "https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTF8fG1hbnxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
          sounds: man,
      },
      {
        title: "woman",
        polish: "kobieta",
        image:
          "https://images.unsplash.com/photo-1495482336510-f7716cc28940?ixid=MXwxMjA3fDB8MHxzZWFyY2h8NDB8fHdvbWFufGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
          sounds: woman,
      },
  ];